/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SubjectStatusEnum,
    SubjectStatusEnumFromJSON,
    SubjectStatusEnumFromJSONTyped,
    SubjectStatusEnumToJSON,
} from './SubjectStatusEnum';

/**
 * 
 * @export
 * @interface UpdateSubjectStatusDTO
 */
export interface UpdateSubjectStatusDTO {
    /**
     * 
     * @type {string}
     * @memberof UpdateSubjectStatusDTO
     */
    subjectId?: string;
    /**
     * 
     * @type {SubjectStatusEnum}
     * @memberof UpdateSubjectStatusDTO
     */
    status?: SubjectStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateSubjectStatusDTO
     */
    message?: string | null;
}

export function UpdateSubjectStatusDTOFromJSON(json: any): UpdateSubjectStatusDTO {
    return UpdateSubjectStatusDTOFromJSONTyped(json, false);
}

export function UpdateSubjectStatusDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateSubjectStatusDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'subjectId': !exists(json, 'subjectId') ? undefined : json['subjectId'],
        'status': !exists(json, 'status') ? undefined : SubjectStatusEnumFromJSON(json['status']),
        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function UpdateSubjectStatusDTOToJSON(value?: UpdateSubjectStatusDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'subjectId': value.subjectId,
        'status': SubjectStatusEnumToJSON(value.status),
        'message': value.message,
    };
}

